import { Injectable } from '@angular/core';
import moment from 'moment';

const EXPIRES_IN = 'expires_in';
const USERID_INFO = 'userInfo';
export const NOT_IN_PLATFORM_USER = 'not_in_platform_user';

export interface IUserSessionResponse {
  token: string;
  emailId: string;
  firstName?: string;
  lastName?: string;
  expires_in: number;
  user_id?: number;
}

@Injectable()
export class LoggedInService {
  setSession(userSessionResponse: IUserSessionResponse): void {
    if (userSessionResponse.expires_in == null) {
      userSessionResponse.expires_in = 3600; // default to 1 hour if expires_in is not provided
    }
    userSessionResponse['id'] = userSessionResponse.user_id; // ensure user_id is set on the response for later use
    userSessionResponse['emailAddress'] = userSessionResponse.emailId; // map emailId to emailAddress for consistency
    delete userSessionResponse.user_id;
    localStorage.setItem(USERID_INFO, JSON.stringify(userSessionResponse));

    const expiresAt = moment().add(userSessionResponse.expires_in, 'second');
    localStorage.setItem(EXPIRES_IN, JSON.stringify(expiresAt.valueOf()));
  }

  isLoggedIn(): boolean {
    if (moment().isBefore(this.getExpirationDate())) {
      return true;
    }
    // invalidate the session token
    return false;
  }

  private getExpirationDate(): moment.Moment {
    const expiresAt = JSON.parse(localStorage.getItem(EXPIRES_IN));
    return moment(expiresAt);
  }
}
